export function fixedColumnOnScroll() {
    console.log('running')
    const submenuDiv = document.querySelector('.fixed-on-scroll');
    const site = document.querySelector(".site");
    const lockSubmenu = () => {
        if (window.pageYOffset > document.querySelector('.site-header').offsetHeight) {
            submenuDiv.classList.add('fixed-on-scroll--fixed');
            site.classList.add('fixed-on-scroll--active');
        } else {
            submenuDiv.classList.remove('fixed-on-scroll--fixed');
            site.classList.remove('fixed-on-scroll--active');
        }
    }

    lockSubmenu();
    window.addEventListener('scroll', lockSubmenu);
}